import { createVuetify } from 'vuetify'
import { theme_dark, theme_light } from '~/themes/themes'

export default defineNuxtPlugin((nuxtApp) => {
   const vuetify = createVuetify({
      components: {},
      defaults: {
         global: {
            ripple: true
         },
         VAppBar: {
            class: 'border-b-sm',
            elevation: 2,
            style: 'border-bottom: 1px solid rgb(var(--v-theme-surfaceEdgeBottom)) !important;'
         },
         VBtn: {
            class: 'text-body-1',
            rounded: 'lg'
         },
         VCard: {
            class: 'emboss',
            density: 'compact',
            elevation: 8
         },
         VCardActions: {
            VBtn: {
               class: 'text-body-1 rounded-pill',
               density: 'compact'
            }
         },
         VCardText: {
            class: 'pa-3 text-body-1',
         },
         VCardTitle: {
            class: "align-center d-flex"
         },
         VCheckbox: {
            color: 'secondary'
         },
         VCombobox: {
            class: 'py-2',
            color: 'secondary',
            density: 'compact',
            variant: 'outlined',
            validateOn: 'blur'
         },
         VDataTableServer: {
            fixedHeader: true,
            noDataText: 'no data available'
         },
         VDivider: {
            class: 'border-opacity-25'
         },
         VFooter: {
            elevation: 8,
            style: 'border-top: 1px solid rgb(var(--v-theme-surfaceLight))'
         },
         VNavigationDrawer: {
            elevation: 4
         },
         VRadioGroup: {
            color: 'secondary'
         },
         VSelect: {
            class: 'py-2',
            color: 'secondary',
            density: 'compact',
            variant: 'outlined',
            validateOn: 'blur'
         },
         VSheet: {
            border: true
         },
         VTextarea: {
            density: 'compact',
            variant: 'outlined'
         },
         VTextField: {
            class: 'py-2',
            color: 'secondary',
            density: 'compact',
            hideDetails: 'auto',
            variant: 'outlined',
            validateOn: 'blur',
            persistentPlaceholder: true
         },
         VToolbar: {
            color: 'surface',
            density: 'compact',
            VBtn: {
               class: 'mr-2',
               style: 'background: rgba(var(--v-theme-surfaceLight), 0.6); height: calc(var(--v-btn-height) - 8px);'
            }
         },
         VToolbarTitle: {
            class: 'mx-0'
         },
         VTooltip: {
            location: 'top'
         }
      },
      display: {
         mobileBreakpoint: 'md',
      },
      theme: {
         defaultTheme: 'theme_dark',
         variations: {
            colors: ['primary', 'secondary', 'surfaceDark', 'tertiary'],
            lighten: 3,
            darken: 3
         },
         themes: {
            theme_dark,
            theme_light
         }
      }
   })

   nuxtApp.vueApp.use(vuetify)
})
